exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".catalogue-position[data-v-6e13f960]{margin-top:45px}@media screen and (max-width:1199px){.catalogue-position[data-v-6e13f960]{margin-top:15px}}.u--red[data-v-6e13f960]{color:#d40f2e}.em--muted[data-v-6e13f960]{opacity:.7}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-6e13f960","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/Components/Checkout/CatalogueOrder.vue
// module id = s2C8
// module chunks = 0